import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiUser, FiMail, FiPhone, FiBriefcase } = FiIcons;

const RegistrationModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    profession: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Registration successful! You will receive workshop details via email.');
    onClose();
    setFormData({ name: '', email: '', phone: '', profession: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={onClose}
          />
          
          {/* Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative bg-gradient-to-br from-gray-800 to-gray-900 border border-blue-400/30 rounded-2xl p-8 w-full max-w-md"
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            >
              <SafeIcon icon={FiX} className="text-2xl" />
            </button>

            {/* Header */}
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-white mb-2">
                Register for FREE
              </h2>
              <p className="text-yellow-400 font-semibold">
                4-Day LIVE Workshop
              </p>
              <p className="text-gray-400 text-sm mt-2">
                Limited seats available
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="relative">
                <SafeIcon icon={FiUser} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-gray-700/50 border border-gray-600 rounded-lg py-3 px-10 text-white placeholder-gray-400 focus:border-blue-400 focus:outline-none transition-colors"
                />
              </div>

              <div className="relative">
                <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-gray-700/50 border border-gray-600 rounded-lg py-3 px-10 text-white placeholder-gray-400 focus:border-blue-400 focus:outline-none transition-colors"
                />
              </div>

              <div className="relative">
                <SafeIcon icon={FiPhone} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full bg-gray-700/50 border border-gray-600 rounded-lg py-3 px-10 text-white placeholder-gray-400 focus:border-blue-400 focus:outline-none transition-colors"
                />
              </div>

              <div className="relative">
                <SafeIcon icon={FiBriefcase} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <select
                  name="profession"
                  value={formData.profession}
                  onChange={handleChange}
                  required
                  className="w-full bg-gray-700/50 border border-gray-600 rounded-lg py-3 px-10 text-white focus:border-blue-400 focus:outline-none transition-colors appearance-none"
                >
                  <option value="">Select Profession</option>
                  <option value="business-owner">Business Owner</option>
                  <option value="founder">Founder</option>
                  <option value="coach">Coach</option>
                  <option value="consultant">Consultant</option>
                  <option value="agency-owner">Agency Owner</option>
                  <option value="service-provider">Service Provider</option>
                  <option value="local-business">Local Business Owner</option>
                  <option value="online-entrepreneur">Online Entrepreneur</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <motion.button
                type="submit"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="w-full bg-gradient-to-r from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 text-white font-bold py-4 px-6 rounded-lg transition-all duration-300"
              >
                🔴 Secure My FREE Seat
              </motion.button>
            </form>

            {/* Trust Elements */}
            <div className="mt-6 text-center text-sm text-gray-400">
              <p>✅ 100% Free • ✅ No Credit Card Required</p>
              <p>✅ Workshop Details Sent Instantly</p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RegistrationModal;